// extracted by mini-css-extract-plugin
export default {"footer":"F_cV","footer__wrapper":"F_cW container-lg","footer__row":"F_cX","footer__links":"F_cY","footer__links__list":"F_cZ"};